window.onload = setTimeout(() => {
    const elementsObf = document.querySelectorAll('.ooo-instagram-media')
    elementsObf.forEach((el) => {
        const div = document.createElement('div');
        const link = el.getAttribute('href')
        if (link === null) return false
        div.innerHTML = el.innerHTML
        div.setAttribute('class', 'ooo-instagram-media')
        div.setAttribute('data-instagram-field', 'permalink')
        el.replaceWith(div)
        div.addEventListener('click', function () {
            window.open(link, '_blank')
        })
    })
}, 500)